module.exports = __webpack_public_path__ + "static/media/tmu-logo.88de3b81.png";